export default "__VITE_ASSET__Do$mCQ1U__"